import { CONFIG } from '../../core/config';
import { ModelStatusPipe } from '../../shared/pipes/model-status.pipe';
import { ModifiableEntity } from '../editable-entity';
import { ModelStatus } from '../model-status';
import { ViewModel } from '../view-model';
import { VersionedEntity } from '../versioned-entity';
import { NameVersionPipe } from '../../shared/pipes/name-version.pipe';
import { IColumn, ICell, IRow, ILookup } from '../../viewmodels/runnableLookups/icell';
import { LookupRow } from './lookup-row';
import { LookupColumn } from './lookup-column';
import { LookupColumnDataType } from './lookup-column-data-type';
interface ILookupRowDictionary {
  [key: string]: LookupRow;
};

export class Lookup extends ModifiableEntity implements ViewModel, VersionedEntity, ILookup {
  readonly friendlyTypeNameSingular = 'Lookups';
  readonly apiRoute: string = CONFIG.apiRoutes.lookups;

  lookupId: string;
  identifier: string;
  label: string;
  description: string;
  version = 0;
  status: ModelStatus = ModelStatus.Draft;
  clonedFrom: string;
  get statusText(): string {
    return new ModelStatusPipe().transform(this.status);
  }
  get nameVersionText(): string {
    return new NameVersionPipe().transform(this);
  }

  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  createdClientSide: boolean;
  get name() { return this.label; }
  set name(value: string) { this.label = value; }

  userDefinedColumns: LookupColumn[] = [];
  userDefinedRows: ILookupRowDictionary = {};

  constructor() {
    super();
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);
    this.lookupId = data.lookupId;
    this.identifier = data.identifier;
    this.label = data.label;
    this.description = data.description;
    this.version = data.version;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.status = data.status;
    this.clonedFrom = data.clonedFrom;
    this.createdClientSide = false;

    if (data.columns) {
      data.columns.forEach(column => {
        const newColumn = new LookupColumn();
        newColumn.loadFromJson(column);
        this.userDefinedColumns.push(newColumn);
      });
    }

    if (data.rows) {
      data.rows.forEach(row => {
        const newRow = new LookupRow();
        newRow.loadFromJson(row);
        this.userDefinedRows[newRow.lookupRowId] = newRow;
      });
    }


    this.userDefinedColumns.forEach(column => {
      if (column.dataType === LookupColumnDataType.Boolean) {
        for (const rowId of Object.keys(this.userDefinedRows)) {
          const row: LookupRow = this.userDefinedRows[rowId];
          if (row.columns[column.lookupColumnId].value.toLowerCase() === 'false') {
            row.columns[column.lookupColumnId].value = '';
          }
        }
      }
    });
  }

  addUserDefinedColumn(column: LookupColumn) {
    let i = 0;
    for (const key in this.userDefinedRows) {
      if (this.userDefinedRows.hasOwnProperty(key)) {
        const row = this.userDefinedRows[key];
        row.addColumn(column, column.cells[i]);
        i = i + 1;
      }
    }

    this.userDefinedColumns.push(column);
    this.userDefinedColumns = this.userDefinedColumns.slice();
  }

  addUserDefinedRow(row: LookupRow) {
    this.userDefinedRows[row.lookupRowId] = row;
  }
}
